const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/hooks/useBreakpoint.ts';
import { useState, useEffect } from 'react';
import { throttle } from 'lodash';

const useBreakpoint = (breakpoint?: number) => {
    const [isSmall, setIsSmall] = useState(window.innerWidth <= (breakpoint ? breakpoint : 600));

    useEffect(() => {
        const calcInnerWidth = throttle(function () {
            setIsSmall(window.innerWidth <= (breakpoint ? breakpoint : 600));
        }, 200);
        window.addEventListener('resize', calcInnerWidth);

        return () => window.removeEventListener('resize', calcInnerWidth);
    }, []);

    return isSmall;
};
export default useBreakpoint;
